import * as React from "react"

import { MainNav } from "@/components/MainNav"

// Full-bleed shell for the takeoff editor: unlike AppShell there is no
// max-width wrapper and no page padding — the canvas owns every pixel
// between the nav and the results panel.
export function EditorShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex h-screen overflow-hidden bg-page text-ink-body">
      <MainNav />
      <main className="min-w-0 flex-1 overflow-hidden">{children}</main>
    </div>
  )
}
